import CloseIcon from "@mui/icons-material/Close";
import { Box, Divider, Grid, IconButton, Modal, Typography } from "@mui/material";
import dayjs from "dayjs";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useForm } from "react-hook-form";
import {
  bindReconcilation,
  dateFormat
} from "../../commonFunctions/CommonFunctions";
import { default as http, default as httpDashboard } from "../../commonFunctions/htttpClientNew";
import WSGoogleChart from "../../Components/Chart/WSGoogleChart";
import WSDataGridForDashboard, {
  IColumns
} from "../../Components/DataGrid/WSDataGridForDashboard";
import { IRows } from "../../Components/Filter/WSFilterComponent";
import { IViewAllLinkColumns } from "../../Components/ViewAllLinkGrid/ViewAllLinkGrid";

interface IListData {
  billList: Array<any>;
  summaryList: Array<any>;
}
interface IBarReconciliation {
  xAxisData: Array<IXAxis>;
}
interface IXAxis {
  scaleType: "bar" | "point";
  data: Array<any>;
}

export const FinancialDashboard: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const [billList, setBillList] = useState<any>([]);
  const [billListFull, setBillListFull] = useState<any>([]);
  const [summaryList, setSummaryList] = useState<any>([]);
  const [due30daysList, setDue30daysList] = useState<any>([]);
  const [chechkIssuedList, setChechkIssuedList] = useState<any>([]);
  const [totalPayment, setTotalPayment] = useState<any>([]);
  const [barReconciliationXAxis, setReconciliationXAxis] = useState<any>();
  const [barReconciliationYAxis, setReconciliationYAxis] = useState<any>();
  const [pieReconciliationData, setPieReconciliationData] = useState<any[]>([]);
  const today = new Date();
  const formattedDate = today.toISOString().split("T")[0]; // Extracts 'YYYY-MM-DD'
  const [leaveEvents, setLeaveEvents] = useState<any>()
  const [leaveEventsResponse, setLeaveEventsResponse] = useState<any>()
  const [open, setOpen] = React.useState(false);
  const source = {
    url: "Bill/search",
    page: 1,
    pageSize: 10,
    filter: [
      {
        field: "DueDate",
        value: formattedDate,
        operator: "gte"
      }
    ],
    sort: []
  };
  useEffect(() => {
    const getBills = async () => {
      try {
        const response: any = await httpDashboard.get("Bill");
        console.log('response are',response);
        if (response) {
          const today = new Date();
          today.setHours(0, 0, 0, 0); // Set time to midnight

          // Filter invoices where invoiceDate is >= today
          response.map((item: any) => {
            item.name = item?.supplier?.name;
            item.check = item?.chequeIssued ? "Yes" : "No";
          });
          setBillListFull(response);

          const filteredInvoices = response
            .filter((invoice: any) => {
              const dueDate = new Date(invoice.scheduledDate);
              return dueDate >= today && invoice.chequeIssued === false; // 💥 Only if cheque not issued;
            })
            .sort((a: any, b: any) => {
              const dateA = new Date(a.dueDate).getTime();
              const dateB = new Date(b.dueDate).getTime();
              return dateA - dateB; // Ascending order by dueDate
            });

          setBillList(filteredInvoices);
          const paymentsum = response?.filter((item: any) => {
            const dueDate = new Date(item?.scheduledDate).toLocaleDateString('en-CA')
            return dueDate === dateFormat(new Date(), 'YYYY-MM-DD');
          });

          paymentsum.map((item: any) => {
            item.supplier = item?.supplier?.name
            item.chequeIssued = item?.check
          })
          setSummaryList(paymentsum)
          const sumOfToday = paymentsum.reduce(
            (total: number, item: any) => total + (Number(item?.amount) || 0),
            0
          );

          let paymentTotal: Array<any> = [];
          paymentTotal.push(["Total Ammount", 500000]);
          paymentTotal.push(["Disposal Ammount", sumOfToday]);
          setTotalPayment(paymentTotal);
          const chkNotIssued = response.filter(
            (item: any) => item.chequeIssued === false
          );
          const chkIssued = response.filter(
            (item: any) => item.chequeIssued === true
          );
          if (response) {
            let chkList: Array<[string, number]> = []; // ✅ Header row
            chkList.push(["Cheque Not Issued", chkNotIssued.length || 0]);
            chkList.push(["Cheque Issued", chkIssued.length || 0]); // Ensure numeric value

            setChechkIssuedList(chkList);
          }
        }
      } catch (error) {
        console.error("Error fetching bills:", error);
      }
    };
    // const getSummary = async () => {
    //   try {
    //     const response: any = await httpDashboard.get("Bill/payments-today");

    //     console.log("response summary is", response)
    //     if (response) {
    //       const filtered = response.filter(
    //         (item: any) => item.checkIssued === true
    //       );

    //       console.log("response in filter payment summary", filtered);

    //       const mapped = filtered.map((item: any) => ({
    //         ...item,
    //         check: "Yes" // since we already filtered for checkIssued === true
    //       }));

    //       setSummaryList(mapped);
    //     }
    //   } catch (error) {
    //     console.error("Error fetching bills:", error);
    //   }
    // };

    const getPaymentSummary = async () => {
      // try {
      //   const response: any = await httpDashboard.get(
      //     "Bill/total-payments-today"
      //   );
      //   if (response) {
      //     let paymentTotal: Array<any> = [];
      //     paymentTotal.push(["Total Ammount", 500000]);
      //     paymentTotal.push(["Disposal Ammount", response?.totalPayments]);
      //     setTotalPayment(paymentTotal);
      //   }
      // } catch (error) {
      //   console.error("Error fetching bills:", error);
      // }
    };
    const getDueDateSummary30Days = async () => {
      try {
        const body: any = { page: 1, pageSize: 1000000, filter: [], sort: [] };
        const response: any = await httpDashboard.post("Bill/search", body);
        if (response && response.data) {
          const currentDate = new Date();
          currentDate.setHours(0, 0, 0, 0);
          const futureDate = new Date();
          futureDate.setHours(0, 0, 0, 0);
          futureDate.setDate(currentDate.getDate() + 30);
          const filteredData = response.data.filter((item: any) => {
            const dueDate = new Date(item.dueDate);
            return dueDate >= currentDate && dueDate <= futureDate;
          });

          // Group by dueDate and sum amounts
          const groupedData = filteredData.reduce((acc: any, item: any) => {
            const date = item.dueDate.split("T")[0]; // Extract only the date part
            acc[date] = (acc[date] || 0) + item.amount;
            return acc;
          }, {} as Record<string, number>);

          // Convert to array format and sort by date
          const output = Object.entries(groupedData)
            .map(([date, totalAmount]) => ({
              date,
              totalAmount
            }))
            .sort(
              (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
            );

          setDue30daysList(output);
        }
      } catch (error) {
        console.error("Error fetching bills:", error);
      }
    };
    const getLast6DaysDate = () => {
      const fromDate = dayjs().subtract(6, "day");

      const dateArray: string[] = [];

      for (let i = 0; i <= 6; i++) {
        dateArray.push(fromDate.add(i, "day").format("DD-MM-YYYY"));
      }
      return dateArray;
    };
    const getBarReconciliation = async () => {
      try {
        const response: any = await bindReconcilation();

        if (response) {
          const formatDate = (dateString: string) => {
            const date = new Date(dateString);
            return date.toLocaleDateString("en-GB"); // DD-MM-YYYY
          };

          const reconcilation = response
            .filter((item: any) => item.reconciling === false)
            .reduce((acc: any, item: any) => {
              const formattedDate = formatDate(item.dueDate);
              acc[formattedDate] = (acc[formattedDate] || 0) + item.amount;
              return acc;
            }, {});

          // Group data for checkIssued
          const checkIssued = response
            .filter((item: any) => item.chequeIssued === true)
            .reduce((acc: any, item: any) => {
              const formattedDate = formatDate(item.dueDate);
              acc[formattedDate] = (acc[formattedDate] || 0) + item.amount;
              return acc;
            }, {});

          // Get unique dates
          const uniqueDates = Array.from(
            new Set([
              ...Object.keys(reconcilation),
              ...Object.keys(checkIssued)
            ])
          ).sort((a, b) => {
            const [dayA, monthA, yearA] = a.split("/").map(Number);
            const [dayB, monthB, yearB] = b.split("/").map(Number);
            return (
              new Date(yearA, monthA - 1, dayA).getTime() -
              new Date(yearB, monthB - 1, dayB).getTime()
            );
          });

          // Prepare series data
          const reconcilationValues = uniqueDates.map(
            (date) => reconcilation[date] || 0
          );
          const checkIssuedValues = uniqueDates.map(
            (date) => checkIssued[date] || 0
          );
          setReconciliationXAxis({ data: uniqueDates });
          setReconciliationYAxis([
            { data: reconcilationValues, label: "Reconciliation" },
            { data: checkIssuedValues, label: "Check" }
          ]);

          //setBarReconciliation()
        }
      } catch (error) {
        console.error("Error fetching bills:", error);
      }
    };

    const getPieReconciliation = async () => {
      try {
        const response: any = await bindReconcilation();

        if (response) {
          const today = new Date().setHours(0, 0, 0, 0);

          const totalReconciliation = response
            .filter(
              (item: any) =>
                item.reconciling === true &&
                new Date(item.dueDate).getTime() < today
            )
            .reduce((acc: number, item: any) => acc + item.amount, 0);

          const totalPendingIssue = response
            .filter(
              (item: any) =>
                item.chequeIssued === false &&
                new Date(item.dueDate).getTime() < today
            )
            .reduce((acc: number, item: any) => acc + item.amount, 0);

          const totalIssuedNotReconciled = response
            .filter(
              (item: any) =>
                item.chequeIssued === true && item.reconciling === false
            )
            .reduce((acc: number, item: any) => acc + item.amount, 0);

          const pieChartData = [
            // ["Label", "Value"],
            ["Reconciled (Excl. Today)", totalReconciliation],
            ["Pending Cheque Issue", totalPendingIssue],
            ["Issued but Not Reconciled", totalIssuedNotReconciled]
          ];

          console.log("piechartdata", pieChartData);
          setPieReconciliationData(pieChartData);
        }
      } catch (error) {
        console.error("Error fetching reconciliation data:", error);
      }
    };

    getPaymentSummary();
    getBills();
    // getSummary();
    getDueDateSummary30Days();
    getBarReconciliation();
    getPieReconciliation();
  }, []);
  const columns: IViewAllLinkColumns[] = [
    {
      fieldName: "name",
      header: "Name"
    },
    {
      fieldName: "invoiceNo",
      header: "Invoice No",
      type: "default"
    },
    {
      fieldName: "invoiceDate",
      header: "Invoice Date",
      type: "date"
    },
    {
      fieldName: "dueDate",
      header: "Due Date",
      type: "date"
    },
    {
      fieldName: "amount",
      header: "Amount",
      type: "default"
    },
    {
      fieldName: "check",
      header: "Check Issued",
      type: "default"
    }
  ];
  const columnsSummary: IColumns[] = [
    {
      fieldName: "supplier",
      header: "Name"
    },
    {
      fieldName: "invoiceNo",
      header: "Invoice No",
      type: "default"
    },
    {
      fieldName: "dueDate",
      header: "Payment Date",
      type: "date"
    },
    {
      fieldName: "amount",
      header: "Amount",
      type: "default"
    },
    {
      fieldName: "chequeIssued",
      header: "IS CHEQUE ISSUED",
      type: "default"
    }
  ];
  // const columnsSummary: IViewAllLinkColumns[] = [
  //     {
  //         fieldName: 'supplierName',
  //         header: 'Name'
  //     },
  //     {
  //         fieldName: 'invoiceNo',
  //         header: 'Invoice No',
  //         type: 'default'
  //     },
  //     {
  //         fieldName: 'paymentDate',
  //         header: 'Payment Date',
  //         type: 'date'
  //     },
  //     {
  //         fieldName: 'amount',
  //         header: 'Amount',
  //         type: 'default'
  //     },

  // ]
  // const columns30days: IViewAllLinkColumns[] = [
  //     {
  //         fieldName: 'date',
  //         header: 'Due Date'
  //     },
  //     {
  //         fieldName: 'totalAmount',
  //         header: 'Total Amount',
  //         type: 'default'
  //     },

  // ]
  const columns30days: IColumns[] = [
    {
      fieldName: "date",
      header: "Due Date"
    },
    {
      fieldName: "totalAmount",
      header: "Total Amount",
      type: "default"
    }
  ];
  const handleFilterchange = (evt: any) => {
    const today = new Date(evt);
    today.setHours(0, 0, 0, 0); // Set time to midnigh
    const filteredInvoices = billListFull.filter((invoice: any) => {
      const dueDate = new Date(invoice.dueDate);
      return dueDate.getTime() === today.getTime();
    });
    setBillList(filteredInvoices);
  };

  const columnsDataBill: IColumns[] = [
    {
      header: "Supplier Name",
      fieldName: "name",
      type: "default"
    },
    {
      header: "Invoice No",
      fieldName: "invoiceNo",
      type: "default"
    },
    {
      header: "Amount",
      fieldName: "amount",
      type: "currency"
    },
    {
      header: "Invoice Date",
      fieldName: "invoiceDate",
      type: "date"
    },
    {
      header: "Schedule Date",
      fieldName: "scheduledDate",
      type: "date"
    },

    {
      header: "Category",
      fieldName: "category",
      type: "default"
    },

    {
      header: "Is Cheque Issued",
      fieldName: "chequeIssued",
      type: "booleanToString",
      groupType: "boolean"
    }
  ];
  const transFormData = (data: any) => {
    if (data) {
      data.map((item: any) => {
        item.name = item?.supplier?.name;
        item.check = item?.chequeIssued ? "Yes" : "No";
      });
      return data;
    }
  };
  const filterRows: IRows[] = [
    {
      label: "Name",
      fieldName: "Supplier.Name",
      type: "text",
      operator: "like"
    },
    {
      label: "Due Name",
      fieldName: "DueDate",
      type: "date",
      dateFormat: "YYYY-MM-DD",
      operator: "eq"
    },
    {
      label: "",
      fieldName: "IsHold",
      type: "checkbox",
      options: [{ label: "Is Hold", value: "false" }],
      operator: "eq"
    }
  ];
  const localizer = momentLocalizer(moment);
  // const leaveEvents = [
  //   {
  //     title: "Annual Leave",
  //     start: new Date(2025, 7, 30), // Aug 30, 2025
  //     end: new Date(2025, 7, 30),
  //     allDay: true
  //   },
  //   {
  //     title: "20000",
  //     start: new Date(2025, 8, 2),
  //     end: new Date(2025, 8, 2),
  //     allDay: true
  //   },
  //   {
  //     title: "40000",
  //     start: new Date(2025, 8, 2),
  //     end: new Date(2025, 8, 2),
  //     allDay: true
  //   },
  // ];
  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
  };
  useEffect(() => {
    async function getCurrntBill() {
      // NewBill/current-month
      const response: any = await http.get('NewBill/current-month');
      if (response && response?.length > 0) {

        const values: any = []
        response?.map((item: any) => {
          values.push({
            title: Number(item?.totalAmount)?.toFixed(2) || "",
            start: new Date(item?.date),
            end: new Date(item?.date),
            allDay: true
          })
        })
        setLeaveEvents(values)
      }
    }
    getCurrntBill();
  }, [])
  const handelEvent = (evt: any) => {
    try {
      const selctedData: any = billListFull?.filter((item: any) => dateFormat(item?.scheduledDate, 'DD-MM-YYYY') === dateFormat(evt?.start, 'DD-MM-YYYY'));
      setLeaveEventsResponse(selctedData)
      setTimeout(() => {
        setOpen(true)
      }, 10);
    }
    catch (e) { }

  }
  const dayPropGetter: (date: Date) => React.HTMLAttributes<HTMLDivElement> = (date) => {
    const day = date.getDay();
    const dateNum = date.getDate();

    if (day === 0 || dateNum === 3 || dateNum === 4) {
      return {
        style: {
          backgroundColor: 'lightgray',
          color: '#fff',
          pointerEvents: 'none' as React.CSSProperties['pointerEvents'],
        },
      };
    }
    return {};
  };

  return (
    <>
      <Grid item container spacing={2}>
        <Grid item sm={12} style={{ padding: 20 }} xs={12}>
          <Typography className="header-text">Dashboard </Typography>
        </Grid>
      </Grid>

      <Grid item container spacing={2}>
        <Grid item sm={12}>
          <Calendar
            popup
            selectable
            defaultDate={new Date()}
            localizer={localizer}
            toolbar={true}
            events={leaveEvents}
            defaultView="month"
            dayPropGetter={dayPropGetter}
            views={["month"]}
            onSelectEvent={handelEvent}
            style={{
              height: 600,
              backgroundColor: "#fff",
              borderRadius: "16px",
              padding: "20px",
              boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
              fontFamily: "Arial, sans-serif",
            }}
            eventPropGetter={(event) => {
              let backgroundColor = "#1976d2"; // default blue
              // if (event?.title?.toLowerCase().includes("sick")) backgroundColor = "#d32f2f"; // red
              // if (event?.title?.toLowerCase().includes("annual")) backgroundColor = "#2e7d32"; // green

              return {
                style: {
                  backgroundColor,
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  padding: "4px 8px",
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                },
              };
            }}
          />
        </Grid>
        <Grid item sm={12} xs={12}>
          <Grid item container spacing={2} flex={1}>
            {/* <Grid item sm={12} xs={12} sx={{ marginBottom: 1 }}>
              <Card
                sx={{
                  transition: "0.3s",
                  width: "100%",
                  height: "100%",

                  "&:hover": {
                    boxShadow: 3 // Change the elevation on hover
                  }
                }}
              >
                <CardHeader
                  sx={{
                    "& .MuiTypography-root": {
                      fontSize: "1rem",
                      fontWeight: "bold"
                    }
                  }}
                  title={"Reconciliation"}
                />
              </Card>
            </Grid> */}


            {/* {pieReconciliationData.length > 0 && (
              <Grid item xs={12}>
                <WSGoogleChart
                  pieVisibility="Straight Angle"
                  title={"Reconciliation Summary"}
                  type="pie"
                  data={pieReconciliationData}
                />
              </Grid>
            )} */}

            <Grid item sm={6} xs={12}>
              <WSGoogleChart
                is3D={true}
                pieVisibility="Center"
                title={"Total Amount Today"}
                type="pie"
                data={totalPayment}
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <WSGoogleChart
                is3D={true}
                pieVisibility="Center"
                title={"Cheque Summary"}
                type="pie"
                data={chechkIssuedList}
              />
            </Grid>
            {/* < Grid item sm={12} xs={12} > */}

            {/* </Grid> */}

            <Grid item sm={12} mt={2} xs={12} sx={{ marginTop: 0 }}>
           
              {summaryList && summaryList?.length > 0 && <WSDataGridForDashboard
                titleSpace={4}
                id="todayPaymentsummary"
                title={`Today's Payment Summary`}
                columns={columnsSummary}
                data={summaryList}
                exportCsv={true}
                exportCsvOption={{ isCheckIssued: true }}
              />}
              {summaryList && summaryList?.length == 0 && <WSDataGridForDashboard
                titleSpace={4}
                id="todayPaymentsummary"
                title={`Today's Payment Summary`}
                columns={columnsSummary}
                data={[]}
                exportCsv={true}
                exportCsvOption={{ isCheckIssued: true }}
              />}
            </Grid>
            {/* <Paper sx={{ marginTop: 5, marginLeft: 2, width: '100%' }}> */}
            {/* <Grid item sm={12} mt={2} xs={12} sx={{ marginLeft: 2, marginRight: 2 }}>
                                <WSDateField control={control} id="dueDate" name="dueDate" rules={{ required: false }} onChange={handleFilterchange} label="Due Date" />
                            </Grid> */}
            <Grid item sm={12} mt={2} xs={12}>
              {/* <WSViewAllLinkGrid rowsCount={10000} title={`Bills`} viewAllLink="/billl/list" id="billDashboard" columns={columns} rows={billList} hideViewAllLink={true} /> */}
              <WSDataGridForDashboard
                pageSize={10}
                // searchBox={{ fieldName: "Category,InvoiceNo,Supplier.Name" }}
                // filterFields={filterRows}
                id="uu"
                title={`Bills`}
                columns={columnsDataBill}
                data={billList}
              />
            </Grid>
            {/* </Paper> */}
            {/* <Grid item sm={12} mt={2} xs={12}>
             
              {due30daysList && (
                <WSDataGridForDashboard
                  title={`Summary`}
                  columns={columns30days}
                  data={due30daysList}
                  id="oo"
                  pageSize={10}
                />
              )}
            </Grid> */}
            {/* <Grid item sm={8} xs={12}>
              < Grid item sm={12} xs={12}>
                                <WSGoogleChart is3D={true} pieVisibility="Center" title={"Department Leaves Chart"} type="pie" data={[]} />
                            </Grid>
            </Grid> */}
          </Grid>
          <Modal open={open} onClose={() => setOpen(false)}>
            <Box sx={style}>
              {/* Close button */}
              <IconButton
                aria-label="close"
                onClick={() => setOpen(false)}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>

              <Typography variant="h6" sx={{ pr: 5 }}>Details</Typography>
              <Divider sx={{ mb: 3 }} />

              <WSDataGridForDashboard
                title="Bills"
                columns={columnsDataBill}
                id="n"
                data={leaveEventsResponse}
              />
            </Box>
          </Modal>
        </Grid>
      </Grid >
    </>
  );
});
